"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = require("@emotion/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; } /* eslint-disable react/forbid-prop-types,consistent-return */
var errorStyles = process.env.NODE_ENV === "production" ? {
  name: "m4z2le",
  styles: "h3{font-weight:700;line-height:17.7px;margin-top:0;}p{margin-bottom:0;}"
} : {
  name: "1llilwp-errorStyles",
  styles: "h3{font-weight:700;line-height:17.7px;margin-top:0;}p{margin-bottom:0;};label:errorStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

// React Error Boundary Docs: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
var ErrorBoundary = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      error: undefined
    };
    return _this;
  }
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);
  return (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.setState({
        error: error
      });
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      var children = this.props.children;
      if (error) {
        return (0, _react.jsx)("div", {
          css: errorStyles
        }, (0, _react.jsx)("h3", null, "Shipment Plan"), (0, _react.jsx)("p", null, "There was an error loading the shipment plan: ", error.message, ". Please reach out to the", ' ', (0, _react.jsx)("a", {
          href: "https://cimpress.slack.com/archives/C7CNT9E2Z",
          target: "_blank",
          rel: "noreferrer"
        }, "#mcp-platform-support Slack channel"), ' ', "for help."));
      }
      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);
}(_react2["default"].Component);
ErrorBoundary.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};